import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { AuthFacade } from '../../features/auth/facade/auth.facade';

export const refreshInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const authFacade = inject(AuthFacade);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || req.url.includes('/auth/')) return throwError(() => error);
      return auth.refreshToken().pipe(
        switchMap(() =>
          next(req.clone({ setHeaders: { Authorization: `Bearer ${auth.getToken()}` } }))
        ),
        catchError(refreshError => { authFacade.logout(true); return throwError(() => refreshError); })
      );
    })
  );
};
